import type { PokemonDefenceInterface } from '../pokemon/pokemon';

// Ability効果に関する判定ヘルパーを集約
// 現状は日本語名（name_ja）で判定する前提

export const hasDefenceAbilityEffects = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return Boolean(isMarvelScale(p) || hasKodaiOrQuark(p));
};

export const isMarvelScale = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'ふしぎなうろこ';
};

// ふしぎなまもりを特性名で判定する
export const isWonderGuard = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'ふしぎなまもり';
};

export const hasKodaiOrQuark = (p: PokemonDefenceInterface | null | undefined): boolean => {
  const name = p?.selected_ability?.name_ja;
  return name === 'こだいかっせい' || name === 'クォークチャージ';
};

// こだいかっせいを特性名で判定する
export const isKodaiKassei = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'こだいかっせい';
};

// 特性名でテラスシェルを判定する
export const isTeraShell = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'テラスシェル';
};

// マルチスケイル/ファントムガードを特性名で判定する
export const isMultiScaleOrShadowShield = (p: PokemonDefenceInterface | null | undefined): boolean => {
  const name = p?.selected_ability?.name_ja;
  return name === 'マルチスケイル' || isShadowShield(p);
};

// 天気無効化特性（エアロック/ノーてんき）を判定する
export const hasWeatherBlockAbility = (p: PokemonDefenceInterface | null | undefined): boolean => {
  const name = p?.selected_ability?.name_ja;
  return name === 'エアロック' || name === 'ノーてんき';
};

// メガランチャーを特性名で判定する
export const isMegaLauncher = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'メガランチャー';
};

// あついしぼうを特性名で判定する
export const isAtsuiShibou = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'あついしぼう';
};

// よびみずを特性名で判定する
export const isYobimizu = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'よびみず';
};

// ちょすいを特性名で判定する
export const isChosui = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'ちょすい';
};

// はりこみを特性名で判定する
export const isHarikomi = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'はりこみ';
};

// はりきりを特性名で判定する
export const isHarikiri = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'はりきり';
};

// ひらいしんを特性名で判定する
export const isHiraishin = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'ひらいしん';
};

// でんきエンジンを特性名で判定する
export const isDenkiEngine = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'でんきエンジン';
};

// ちくでんを特性名で判定する
export const isChikuden = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'ちくでん';
};

// かたいツメを特性名で判定する
export const isKataitume = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'かたいツメ';
};

// ちからずくを特性名で判定する
export const isTikarazuku = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'ちからずく';
};

// テクニシャンを特性名で判定する
export const isTechnician = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'テクニシャン';
};

// ファントムガードを特性名で判定する
export const isShadowShield = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'ファントムガード';
};

// パンクロックを特性名で判定する
export const isPunkRock = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'パンクロック';
};

// もうかを特性名で判定する
export const isMouka = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'もうか';
};

// トランジスタを特性名で判定する
export const isTaranzisuta = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'トランジスタ';
};

// ひとでなしを特性名で判定する
export const isHitodenashi = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'ひとでなし';
};

// サンパワーを特性名で判定する
export const isSunpower = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'サンパワー';
};

// たいねつを特性名で判定する
export const isTaineetu = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'たいねつ';
};

// きよめのしおを特性名で判定する
export const isKiyomenosio = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'きよめのしお';
};

// げきりゅうを特性名で判定する
export const isGekiryu = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'げきりゅう';
};

// しんりょくを特性名で判定する
export const isSinryoku = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'しんりょく';
};

// よわきを特性名で判定する
export const isDefeatist = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'よわき';
};

// うるおいボイスを特性名で判定する
export const isUruoiVoice = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'うるおいボイス';
};

// むしのしらせを特性名で判定する
export const isMusinosirase = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'むしのしらせ';
};

// こおりのりんぷんを特性名で判定する
export const isKoorinorinpun = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'こおりのりんぷん';
};

// ごりむちゅうを特性名で判定する
export const isGorimutixyuu = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'ごりむちゅう';
};

// はがねつかいを特性名で判定する
export const isHaganetukai = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'はがねつかい';
};

// はがねのせいしんを特性名で判定する
export const isHaganenoseisin = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'はがねのせいしん';
};

// かぜのりを特性名で判定する
export const isKazenori = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'かぜのり';
};

// ぼうだんを特性名で判定する
export const isBoudan = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'ぼうだん';
};

// きれあじを特性名で判定する
export const isKireazi = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'きれあじ';
};

// てきおうりょくを特性名で判定する
export const isTekiourixyoku = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'てきおうりょく';
};

// ねつぼうそうを特性名で判定する
export const isNetubousou = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'ねつぼうそう';
};

// どくぼうそうを特性名で判定する
export const isDokubousou = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'どくぼうそう';
};

// すなのちからを特性名で判定する
export const isSunanotikara = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'すなのちから';
};

// すりぬけを特性名またはフラグで判定する
export const isSurinuke = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'すりぬけ';
};

// てんねんを特性名で判定する
export const isTennen = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'てんねん';
};

// アナライズを特性名で判定する
export const isAnalyze = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'アナライズ';
};

// がんじょうあごを特性名で判定する
export const isGanzixyouago = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'がんじょうあご';
};

// もらいびを特性名で判定する
export const isMoraibi = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'もらいび';
};

// ハドロンエンジンを特性名で判定する
export const isHadoronengine = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'ハドロンエンジン';
};

// こんじょうを特性名で判定する
export const isKonjou = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'こんじょう';
};

// スカイスキンを特性名で判定する
export const isSkySkin = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'スカイスキン';
};

// ノーマルスキンを特性名で判定する
export const isNormalSkin = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'ノーマルスキン';
};

// フェアリースキンを特性名で判定する
export const isFailySkin = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'フェアリースキン';
};

// フリーズスキンを特性名で判定する
export const isFreezeSkin = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'フリーズスキン';
};

// かんそうはだを特性名で判定する
export const isKansouHada = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'かんそうはだ';
};

// こんがりボディを特性名で判定する
export const isKongariBody = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'こんがりボディ';
};

// すいほうを特性名で判定する
export const isSuihou = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'すいほう';
};

// エレキスキンを特性名で判定する
export const isErekiSkin = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'エレキスキン';
};

// そうだいしょうを特性名で判定する
export const isSoudaisixyou = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'そうだいしょう';
};

// くさのけがわを特性名で判定する
export const isKusanokegawa = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'くさのけがわ';
};

// わざわいのたまを特性名で判定する
export const isWazawainoutama = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'わざわいのたま';
};

// ちからもち・ヨガパワーを特性名で判定する
export const isTikaramoti = (p: PokemonDefenceInterface | null | undefined): boolean => {
  const name = p?.selected_ability?.name_ja;
  return name === 'ちからもち' || name === 'ヨガパワー';
};

// わざわいのつるぎを特性名で判定する
export const isWazawainoturugi = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'わざわいのつるぎ';
};

// わざわいのうつわを特性名で判定する
export const isWazawainoutuwa = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'わざわいのうつわ';
};

// ハードロック/フィルターを特性名で判定する
export const isHardrock = (p: PokemonDefenceInterface | null | undefined): boolean => {
  const name = p?.selected_ability?.name_ja;
  return name === 'ハードロック' || name === 'フィルター';
};

// わざわいのおふだを特性名で判定する
export const isWazawainoohuda = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'わざわいのおふだ';
};

// ダークオーラを特性名で判定する
export const isDarkAura = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'ダークオーラ';
};

// フェアリーオーラを特性名で判定する
export const isFairyAura = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'フェアリーオーラ';
};

// ふゆうを特性名で判定する
export const isHuyuu = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'ふゆう';
};

// いろめがねを特性名で判定する
export const isIromegane = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'いろめがね';
};

// ファーコートを特性名で判定する
export const isFurCoat = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'ファーコート';
};

// ひひいろのこどうを特性名で判定する
export const isHihiironokodou = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'ひひいろのこどう';
};

// ぼうおんを特性名またはフラグで判定する
export const isBouon = (p: PokemonDefenceInterface | null | undefined): boolean => {
  const name = p?.selected_ability?.name_ja;
  return name === 'ぼうおん' || name === '防音';
};

// てつのこぶしを特性名で判定する
export const isTetunokobushi = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'てつのこぶし';
};

// りゅうのあぎとを特性名で判定する
export const isRyunoagito = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'りゅうのあぎと';
};

// すてみを特性名で判定する
export const isSutemi = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'すてみ';
};

// スロースタートを特性名で判定する
export const isSlowStart = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return p?.selected_ability?.name_ja === 'スロースタート';
};

// よわきは設定されていれば常時発動扱いにする
export const isDefeatistActive = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return isDefeatist(p);
};

// スロースタートは設定されていれば常時発動扱いにする
export const isSlowStartActive = (p: PokemonDefenceInterface | null | undefined): boolean => {
  return isSlowStart(p);
};
